ready(function () {
  console.log('S4W is ready!');


  var $form = document.querySelector('#create_customer');
  if ($form) {

    var $b2b = document.querySelector('#RegisterForm-B2b');
    var $wrapper = document.querySelector('.form__b2b');
    var $b2bwrapper = document.querySelector('.form__b2b');
    var $fields = $wrapper.querySelectorAll('.form__field');
    var $b2bFields = $b2bwrapper.querySelectorAll('.form__field');
    var $inputs = $form.querySelectorAll('input[data-name]');
    var $b2binputs = $b2bwrapper.querySelectorAll('input[data-name]');
    var $customerNoteInput = document.querySelector('#RegisterForm-CustomerNote');
    var CustomerNote = {};
    $b2b.addEventListener('change', function () {
      if ($b2b.checked) {
        $b2bwrapper.classList.add('js-checked');
        $b2bFields.forEach(function ($field) {
          $field.classList.remove('hidden');
          var $input = $field.querySelector('input');
          $input.setAttribute('required', 'required');
        });
      } else {
        $b2bwrapper.classList.remove('js-checked');
        $b2bFields.forEach(function ($field) {
          $field.classList.add('hidden');
          var $input = $field.querySelector('input');
          $input.value = '';
          $input.removeAttribute('required');
        });
      }
      updateCustomerNote();
    });

    $inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        const dataName = input.getAttribute('data-name');

        if (dataName !== 'company_name') {
          input.value = input.value.replace(/\s/g, '');
        }
        updateCustomerNote();
      });
    })
    function updateCustomerNote() {
      CustomerNote = {};
      if ($b2b.checked) {
        CustomerNote.b2b = 'on';
      } else {
        CustomerNote.b2b = 'off';
      }
      $inputs.forEach(function (input) {
        var add = false;
        var isB2b = input.closest('.form__b2b');
        var isExtra = input.closest('.form__extra');
        if ($b2b.checked && isB2b) {
          add = true;
        } else if (!isB2b) {
          add = true;
        }

        if (add) {
          var value = input.value;
          var name = input.getAttribute('data-name');
          if (value !== '') {
            CustomerNote[name] = value;
          }
        }
      });

      $customerNoteInput.value = JSON.stringify(CustomerNote);
    }
    updateCustomerNote();


    var $password = document.querySelector('#register-password');
    var $passwordConfirm = document.querySelector('#register-password_confirmation');
    var $passwordError = document.querySelector('.password-confirm-error');
    var $submit = document.querySelector('#register-submit');

    function validatePasswords() {
      const password = $password.value;
      const confirm = $passwordConfirm.value;

      if (confirm && password !== confirm) {
        $passwordError.style.display = 'block'; // mostra l'errore
        $submit.disabled = true;
      } else {
        $passwordError.style.display = 'none'; // nasconde l'errore
        $submit.disabled = false;
      }
    }

    // Evento su conferma password
    $passwordConfirm.addEventListener('input', function () {
      validatePasswords();
    });

    // Evento su password (solo se conferma è già stata compilata)
    $password.addEventListener('input', function () {
      if ($passwordConfirm.value !== '') {
        validatePasswords();
      }
    });



    var $vat = document.querySelector('#RegisterForm-vat_number');
    var $vatError = document.querySelector('.vat-error');
    if ($vat) {
      // Valida che abbia 2 lettere + 11 cifre
      function isValidItalianVAT(vat) {
        return /^[A-Za-z]{2}\d{11}$/.test(vat);
      }

      function validateVAT() {
        if ($vat.value !== '' && !isValidItalianVAT($vat.value)) {
          $vatError.style.display = 'block';
          $submit.disabled = true;
        } else {
          $vatError.style.display = 'none';
          $submit.disabled = false;
        }
      }

      $vat.addEventListener('input', validateVAT);
    }

  }


  // var $productOptions = document.querySelectorAll('.block.product-info__block.product-info__block--sm[data-current-variant-id]');
  // var variantIds = [];
  // if ($productOptions.length > 0) {
  //   $productOptions.forEach(function ($input) {
  //     var variantId = $input.getAttribute('data-current-variant-id');
  //     variantIds.push(variantId);
  //   });
  //   updateMediasVisibility(variantIds);
  // }

  var $gallery = document.querySelector('.media-gallery__viewer');
  if ($gallery) {
    if (window.innerWidth < 1024) { return; }
    var $items = document.querySelectorAll('.media-viewer__item');
    $items.forEach(function ($this) {
      $this.addEventListener('click', function () {
        var hq = $this.getAttribute('data-media-hq');
        var width = $this.getAttribute('data-media-width');
        var height = $this.getAttribute('data-media-height');
        var src = hq.replace('/files/files/', '/files/')
        // console.log('click', src, width, height);
        openLightbox(src, width, height);
      });
    });

    var $imageWrapper = document.querySelector('.media-gallery__lb-image');
    var $wrapper = document.querySelector('.media-gallery__lb-content');
    var $close = document.querySelectorAll('.media-gallery__lb-close, .media-gallery__lb-overlay');
    var $lb = document.querySelector('#lb');
    $close.forEach(function ($this) {
      $this.addEventListener('click', function () {
        closeLightbox();
      });
    });
    function appendImage(src, width, height) {
      var image = new Image();
      image.src = src;

      // Calcola le dimensioni massime del wrapper
      var maxWidth = window.innerWidth - 150; // 90% della larghezza della finestra
      var maxHeight = window.innerHeight - 150; // 90% dell'altezza della finestra

      // Calcola il rapporto di scala per mantenere le proporzioni
      var scale = Math.min(maxWidth / width, maxHeight / height);

      var finalWidth = width * scale;
      var finalHeight = height * scale;
      // Dimensioni finali basate sul rapporto di scala
      if (maxHeight > height && maxWidth > width) {
        finalWidth = width;
        finalHeight = height;
      }

      // Applica le dimensioni al wrapper
      $wrapper.style.width = `${finalWidth}px`;
      $wrapper.style.height = `${finalHeight}px`;

      // Inserisce l'immagine nel contenitore
      $imageWrapper.innerHTML = '';
      $imageWrapper.appendChild(image);
    }
    function closeLightbox() {
      $lb.classList.remove('is-visible');
      $imageWrapper.innerHTML = '';
    }
    function openLightbox(src, width, height) {
      appendImage(src, width, height);
      $lb.classList.add('is-visible');
    }
    // openLightbox('//del-torre.myshopify.com/cdn/shop/files/CSBASB0154.jpg?1657', 1231, 1225);
  }


  var $sectionTech = document.querySelector('.section--tech');
  if ($sectionTech) {
    const productInfoBlock = document.querySelector('.product-info__block.product-description');

    if (productInfoBlock) {
      const buttonHTML = '<button class="btn btn--secondary" type="button" id="goto-tech">Vedi caratteristiche e scheda tecnica</button><br><br>';
      productInfoBlock.insertAdjacentHTML('afterend', buttonHTML);
      const button = document.querySelector('#goto-tech');
      button.addEventListener('click', function () {
        // Calcola l'altezza dell'header
        const headerHeight = document.querySelector('.header')?.offsetHeight || 0;

        // Calcola la posizione della sezione
        const sectionTop = $sectionTech.getBoundingClientRect().top + window.pageYOffset;

        // Scrolla alla posizione con offset per l'header
        window.scrollTo({
          top: sectionTop - headerHeight, // Compensa l'altezza dell'header
          behavior: 'smooth' // Scorrimento fluido
        });
      });
    }

  }



  var $popupTriggers = document.querySelectorAll('.s4w-popup__trigger');
  var $popup = document.querySelector('.s4w-popup__wrapper');
  var $popupTriggers2 = document.querySelectorAll('.s4w-popup2__trigger');
  var $popup2 = document.querySelector('.s4w-popup2__wrapper');
  if ($popupTriggers.length > 0) {
    var $closeSidebar = document.querySelector('.drawer__close-btn');
    $popupTriggers.forEach(function ($trigger) {
      $trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if ($closeSidebar) {
          $closeSidebar.click();
        }
        $popup.classList.add('is-visible');
      });
    });
    var $close = document.querySelectorAll('.s4w-popup__close, .s4w-popup__overlay');
    $close.forEach(function ($this) {
      $this.addEventListener('click', function (e) {
        e.preventDefault();
        $popup.classList.remove('is-visible');
      });
    });
  }
  if ($popupTriggers2.length > 0) {
    var $closeSidebar = document.querySelector('.drawer__close-btn');
    $popupTriggers2.forEach(function ($trigger) {
      $trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if ($closeSidebar) {
          $closeSidebar.click();
        }
        $popup2.classList.add('is-visible');
      });
    });
  }
  var $popupLinks = document.querySelectorAll('a[href="#normative"]');
  if ($popupLinks.length > 0) {
    var $closeSidebar = document.querySelector('.drawer__close-btn');
    $popupLinks.forEach(function ($trigger) {
      $trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if ($closeSidebar) {
          $closeSidebar.click();
        }
        $popup2.classList.add('is-visible');
      });
    });
  }
  if ($popup2) {
    var $close = document.querySelectorAll('.s4w-popup2__close, .s4w-popup2__overlay');
    $close.forEach(function ($this) {
      $this.addEventListener('click', function (e) {
        e.preventDefault();
        $popup2.classList.remove('is-visible');
      });
    });
  }


  // var $id = document.querySelector('.js-product-form input[name="id"]');
  // if ($id) {
  //   $id.addEventListener('change', this.checkProductQuantity.bind(this));
  // }



});

function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

function updateMediasVisibility(ids) {
  // console.log(ids);

  var media_ids = ids;
  if (Array.isArray(ids) === false) {
    media_ids = [ids.toString()];
  } else {
    media_ids = ids.map(function (id) {
      return id.toString();
    });
  }
  const productMedia = document.querySelectorAll('.media-viewer__item[data-variant-ids], .media-thumbs__item[data-variant-ids]');

  var thumbmedia = null;
  productMedia.forEach(media => {
    const isThumb = media.classList.contains('media-thumbs__item');
    const variantIds = media.dataset.variantIds.split(',').filter(Boolean);
    const allPresent = media_ids.every(value => variantIds.includes(value));
    // console.log(media_ids, variantIds, allPresent, media);
    // console.log(variantIds.includes(media_id + ''), media_id + '', variantIds);
    if (allPresent) {
      // console.log(media);
      if (isThumb && thumbmedia === null) {
        thumbmedia = media;
      }
      media.style.display = 'block';
    } else {
      media.style.display = 'none';
    }
  });


  // console.log(thumbmedia);

  window.dispatchEvent(new CustomEvent('on:reload-gallery'));
  setTimeout(() => {
    if (thumbmedia) {
      // console.log(thumbmedia);

      const button = thumbmedia.querySelector('button');
      if (!button.classList.contains('is-active')) {
        thumbmedia.click();
      }
    } else {
      const firstThumb = document.querySelector('.media-thumbs__item:not([data-variant-ids])');

      // console.log(firstThumb);

      if (firstThumb) {
        const button = firstThumb.querySelector('button');
        if (!button.classList.contains('is-active')) {
          firstThumb.click();
        }
      }
    }
  }, 500)
}

document.addEventListener('on:variant:change', (event) => {

  var media_id = event.detail.variant?.id || null;
  // console.log('Variant changed', media_id);
  if (media_id) {
    // console.log(event);
    updateMediasVisibility(media_id)

  }

});



